import Grid       from '@mui/material/Grid'
import Box        from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper      from '@mui/material/Paper'
import '../../App.css'
import '../../style.css'

function GBTitle() {

  return (
    <Box sx={{ m : 1 , p : 4}}>
      {/* 画面 */}
      <Paper sx={{ m: 1, p: 1 ,
              bgcolor      : '#f5f5dc'  ,
              borderRadius : "1px"      , 
              height       : "250px"    ,
              width        : '250px'    ,
              position     : 'absolute' , // 絶対位置指定
              top          : '20px'     , // 縦位置を50pxに指定
              left         : '40px'     , // 横位置を20pxに指定
      }}>
        <br/><br/><br/><br/><br/>
        <Grid container spacing={0}>
            {/* タイトル表示 */}
            <Grid item xs={12} align="center">
              <Typography
                className="blinking-text" // 点滅するクラスを追加
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "15px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>STARTボタンをおしてね</Typography>
            </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={2}>
          <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  );
}

export default GBTitle
